import { api } from "./client";
import type { Plan, PlanUpdateRequest } from "../../types/usage";

export async function listPlans(): Promise<Plan[]> {
  const response = await api.get("/admin/plans");
  return response.data;
}

export async function updatePlan(planId: string, data: PlanUpdateRequest): Promise<Plan> {
  const response = await api.put(`/admin/plans/${planId}`, data);
  return response.data;
}
